<template>
  <VView class="contest-personal" header="Wynik">
    <VText big center>Twoje imię</VText>

    <VBlock max-width="500px">
      <VForm ref="form"
        :fields="fields"
        @update="onFormUpdate($event)"
      />

      <transition name="bounceUp" appear>
        <VButton @click="submit()">Zapisz!</VButton>
      </transition>
    </VBlock>
  </VView>
</template>

<script>
import { mapState } from 'vuex';
import { SET_PERSONAL_FIELD } from '@/store';
import {
  FIELD_TYPE_TEXT,
  FIELD_TYPE_EMAIL,
  FIELD_TYPE_COMMENT,
} from '@/components/VForm.vue';

export default {
  name: 'ContestPersonal',

  data: () => ({
    isLoading: false,
  }),

  computed: {
    ...mapState({
      fields(state) {
        return [
          {
            key: 'firstName',
            type: FIELD_TYPE_TEXT,
            isRequired: true,
            label: 'Twoje imię',
            value: state.personal.firstName,
            width: '100%',
          },
        ];
      },

      payload: state => ({
        ...state.personal,
        ...state.legal,
        answer: state.answer,
        attachment: state.attachment,
        score: state.score,
      }),
    }),
  },

  methods: {
    onFormUpdate({ key, value }) {
      this.$store.commit(SET_PERSONAL_FIELD, { key, value });
    },

    async submit() {
      if (this.isLoading) {
        return;
      }

      const isValid = this.$refs.form.validate();

      if (!isValid) {
        return;
      }

      this.isLoading = true;

      try {
        await this.$bricodes.createEntry(this.payload);

        this.$router.push('/contest/end');

      } catch (error) {
        this.$router.push(`/contest/error?to=/contest/personal`);

        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.contest-personal {
  ::v-deep .block {
    margin-top: 5px !important;
  }
  ::v-deep .form {
    margin: 0;
    padding: 0;

    .form-label {
      display: none;

      &::before {
        display: none;
      }
    }

    input {
      border-radius: 10px;
      text-align: center;
      font-size: font(30px, 40px);
    }
  }

  ::v-deep .button__content {
    animation: none;
  }
}
</style>
